<template>
    <div class="contacts">
        <h1>{{ metaData.header }}</h1>
    </div>
</template>

<script>
    export default {
        name: "Contacts",
        data() {
            return {
                metaUrl: '/contacts'
            }
        }
    }
</script>

<style scoped>

</style>
